import { EntityBase } from './entityBase';

import type { EmptyJsonPub, EmptyPropsPub } from './entityBase';
import type { EntityNamePvt } from '@/types/common/entityPvt';

/**
 * Entityの抽象クラス.
 * Repositoryを持たない一時的なEntity.
 */
export abstract class EntityPvt<T, J> extends EntityBase<T, J, EmptyPropsPub, EmptyJsonPub> {
  /**
   * Entity名
   */
  abstract get entityName(): EntityNamePvt;

  /**
   * キー
   */
  get key(): string {
    return `${this.entityName}#${this.entityKey}`;
  }

  /**
   * キーが同じかどうか
   * @param key キー
   * @returns 同じか
   */
  isEqualKey(key: string): boolean {
    return key === this.key;
  }

  /**
   * Pub jsonにする
   * @returns Pub json
   */
  toJsonPub() {
    return null;
  }
}
